import {addContent, addContentNewLine, addOutputLine, isContinueProcessing, saveExtendedFile, saveLog} from "./util";
import {
    readAggressiveness,
    readAllAlerts,
    readAutoMode,
    readAutoModeStats, readBasalInsulin, readCfProfile,
    readClAttempting,
    readIcrProfile,
    readPriming,
    readPumpAlarm,
    readRefill,
    readRefillDeduced,
    readReservoir,
    readSensorStarted,
    readSensorStopped, readTargetGlucose,
    readTdd,
    readTddAlgo,
    // readDisplayedAlert,
    // readAudioAlert,
    // readAcknowledgedAlert,
    // readVibrateAlert,
    readWeight
} from "./process-spec-misc";
import * as globals from "./globalDef";
import { get } from "aws-amplify/api";

const glucoseCon = 0.05551;
const mmollUnits = "mmol/l";

const userIdHead = 'userid:';
const startTimeHead = 'starttime:';
const endTimeHead = 'endtime:';
const versionHead = 'version:';
const saveFileHead = 'savefile:';
const getAutomodeUsageHead = 'usage:';
const getReservoirHead = 'reservoir:';

const modeMeal = "meal";
const modeBolus = "bolus";
const modeInfusion = "inf";
const modeCgm = "cgm";
const modeBg = "bg";
const modeKetone = "ket";

let getAutomodeUsage = false;
let getReservoir = false;

let filePrefix = "";

export async function extractSpecification(self, specificationText) {
    // clear log etc
    self.props.setContent("");
    self.props.setSpecification([]);
    addContentNewLine(self, "Extracting specification from " + self.props.file.name);
    const arrayOfLines = specificationText.split("\n");

    let line;
    let userId = '';
    let startTime = '';
    let endTime = '';
    let version = 1;
    let outFile;

    do {
        line = extractLine(self, arrayOfLines);
        if (line !== null) {
            if (line.startsWith(userIdHead)) {
                userId = line.replace(userIdHead, "").trim();
            } else if (line.startsWith(startTimeHead)) {
                startTime = line.replace(startTimeHead, "").trim();
            } else if (line.startsWith(endTimeHead)) {
                endTime = line.replace(endTimeHead, "").trim();
            } else if (line.startsWith(versionHead)) {
                version = line.replace(versionHead, "").trim();
            } else if (line.startsWith(saveFileHead)) {
                outFile = line.replace(saveFileHead, "").replace(/"/g, "").trim();
                const spec = self.props.specification;
                spec.push({
                    [userIdHead]: userId,
                    [startTimeHead]: startTime,
                    [endTimeHead]: endTime,
                    [versionHead]: version,
                    [saveFileHead]: outFile
                });
                self.props.setSpecification(spec);
                // process specification
                await processSpecification(self);

            } else if (line.indexOf(getAutomodeUsageHead) >= 0) {
                getAutomodeUsage = line.indexOf("true") >= 0;
            } else if (line.indexOf(getReservoirHead) >= 0) {
                getReservoir = line.indexOf("true") >= 0;
            }
        }
    }
    while ((line !== null) && isContinueProcessing(self)) ;
}

export function extractLine(self, arrayOfLines) {
    let line = null;
    while ((arrayOfLines.length > 0) && (line === null)) {
        line = arrayOfLines[0].replace(/\r/g, '');
        arrayOfLines.shift();
        addContentNewLine(self, "Reading: " + line);
        line = line.trim().toLowerCase();
        if (line.length > 0) {
            if (line[0] === '#') {
                line = null;
            }
        } else {
            line = null;
        }
    }
    return line;
}

export async function processSpecification(self) {

    if (self.props.specification.length === 0) {
        self.props.setIsProcessing(false);
        self.props.setIsStopping(false);
        addContentNewLine(self, "Saving log file");
        saveLog(self);
    } else {
        const tmpSpecs = self.props.specification;
        const spec = tmpSpecs[0];
        tmpSpecs.shift();
        self.props.setSpecification(tmpSpecs);

        const userId = spec[userIdHead];
        const startTime = spec[startTimeHead];
        const endTime = spec[endTimeHead];
        const version = spec[versionHead];
        const outFile = spec[saveFileHead];

        self.props.setOutputArray([]);

        addContentNewLine(self, "");
        addContentNewLine(self, "*******************************************************************************************************");
        addContentNewLine(self, "Started processing: " + userId + " From: " + startTime + " To (inclusive): " + endTime +
            " Get CL usage: " + (getAutomodeUsage ? 'true' : 'false') +
            " Get reservoir: " + (getReservoir ? 'true' : 'false') +
            " Version: " + version + ' Output file name: "' + outFile + '"'
        );

        // create header
        createHeader(self, outFile);
        if (!isContinueProcessing(self)) {
            return;
        }

        // await readTargetGlucose(self, userId, startTime, endTime); // TODO: remove

        // read enteral boluses
        await readEnteralBolus(self, userId, startTime, endTime, version);
        readVoids(self);
        await readBolus(self, userId, startTime, endTime, version);
        await readInfusion(self, userId, startTime, endTime, version);
        await readCgm(self, userId, startTime, endTime, version);
        await readBg(self, userId, startTime, endTime, version);
        writeStartTime(self, userId, startTime);

        // miscellaneous
        await readKetone(self, userId, startTime, endTime, version);
        await readAggressiveness(self, userId, startTime, endTime, version);
        await readAutoMode(self, userId, startTime, endTime, version, false);
        await readClAttempting(self, userId, startTime, endTime, version, false);
        await readWeight(self, userId, startTime, endTime, version);
        await readPriming(self, userId, startTime, endTime, version);
        await readRefill(self, userId, startTime, endTime, version);
        await readRefillDeduced(self, userId, startTime, endTime, version);
        await readPumpAlarm(self, userId, startTime, endTime, version);
        await readSensorStarted(self, userId, startTime, endTime, version);
        await readSensorStopped(self, userId, startTime, endTime, version);
        // await readAudioAlert(self, userId, startTime, endTime, version);
        // await readVibrateAlert(self, userId, startTime, endTime, version);
        // await readDisplayedAlert(self, userId, startTime, endTime, version);
        // await readAcknowledgedAlert(self, userId, startTime, endTime, version);
        await readAllAlerts(self, userId, startTime, endTime, version);
        await readTdd(self, userId, startTime, endTime, version);
        await readTddAlgo(self, userId, startTime, endTime, version);

        if (getAutomodeUsage) {
            filePrefix = await readAutoModeStats(self, userId, startTime, endTime, version);
        }

        if (getReservoir) {
            await readReservoir(self, userId, startTime, endTime, version);
        }

        // read settings
        await readTargetGlucose(self, userId, startTime, endTime);
        await readBasalInsulin(self, userId, startTime, endTime);
        await readCfProfile(self, userId, startTime, endTime);
        await readIcrProfile(self, userId, startTime, endTime);

        // end finishing
        addContentNewLine(self, "");
        addContentNewLine(self, "Saving extended file");
        saveExtendedFile(self, filePrefix + outFile);
        // processSpecification(self);
    }
}

function createHeader(self, userid) {
    addOutputLine(self, "ID: " + userid);
    addOutputLine(self, "Weight:        0.000 kg");
    addOutputLine(self, "Basal:          0.0 U/day");
    addOutputLine(self, "Basal rate in 30min steps (U/h):");
    addOutputLine(self, "    0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0");
    addOutputLine(self, "    0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0");
    addOutputLine(self, "    0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0");
    addOutputLine(self, "    0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0");
    addOutputLine(self, "");
}

function writeMeal(self, obj) {
    addOutputLine(self, getDateTime(obj.date) + '\t' + obj.meal.val);
}

function writeBolus(self, obj) {
    if (obj.stepBolus) {
        addOutputLine(self, getDateTime(obj.date) + '\t' + obj.stepBolus.val + '\t 0 \t R');
    } else if (obj.extBolus) {
        addOutputLine(self, getDateTime(obj.date) + '\t' + obj.extBolus.value + '\t ' + obj.extBolus.duration + '\t R');
    }
}

function writeInfusion(self, obj) {
    addOutputLine(self, getDateTime(obj.date) + '\t' + obj.inf.val + '\tR');
}

function writeCgm(self, obj) {
    addOutputLine(self, getDateTime(obj.date) + '\t' +
        (obj.cgm.u.toLowerCase() === mmollUnits ? obj.cgm.val : obj.cgm.val * glucoseCon));
}

function writeKetone(array, obj) {
    addOutputLine(array, getDateTime(obj.date) + '\t' + obj.ket.val);
}

function writeBg(self, obj) {
    addOutputLine(self, getDateTime(obj.date) + '\t' +
        (obj.bg.units.toLowerCase() === mmollUnits ? obj.bg.value : obj.bg.value * glucoseCon) +
        (obj.bg.isCalibrating ? ' c' : ''));
}

/**
 * Fetches all items for a given data category and returns them as an array,
 * without writing anything to the output. Intended for use when multiple
 * categories need to be collected, merged, and sorted before writing (e.g. {@link readAllAlerts}).
 * Respects {@link isContinueProcessing} and returns a partial list if processing is stopped.
 * @param {string} userid - The user ID to query.
 * @param {string} version - Data schema version string.
 * @param {string} startTime - Query start time (epoch ms).
 * @param {string} endTime - Query end time (epoch ms).
 * @param {object} self - Output state object (used for progress dots and stop checks).
 * @param {string} mode - Data category key (e.g. `"alert_audio"`).
 * @returns {Promise<object[]>} Array of all data records for the category.
 */
export async function collectDataCategory(userid, version, startTime, endTime, self, mode) {
    const allItems = [];
    let tempResult = {};
    tempResult.LastEvaluatedKey = "";
    let firstRun = true;
    while (tempResult.LastEvaluatedKey || firstRun) {
        firstRun = false;
        tempResult = await subjectData(tempResult.LastEvaluatedKey, userid, mode, version, startTime, endTime);
        addContent(self, '.');
        for (const obj of tempResult.Items) {
            if (!isContinueProcessing(self)) {
                return allItems;
            }
            allItems.push(obj);
        }
    }
    return allItems;
}

export async function processDataCategory(userid, version, startTime, endTime, self, mode, writeLine) {
    let tempResult = {};
    tempResult.LastEvaluatedKey = "";
    let firstRun = true;
    while (tempResult.LastEvaluatedKey || firstRun) {
        firstRun = false;
        tempResult  = await subjectData(tempResult.LastEvaluatedKey, userid, mode, version, startTime, endTime);
        addContent(self, '.');
        let obj;
        for (obj of tempResult.Items) {
            if (!isContinueProcessing(self)) {
                return;
            }
            writeLine(self, obj);
        }
    }
}

export async function processDataCategoryStats(userid, version, startTime, endTime, self, mode, writeLine) {
    let tempResult = {};
    tempResult.LastEvaluatedKey = "";
    let firstRun = true;
    let automodeOn = 0;
    let automodeOff = 0;
    let automodeAttempting = 0;
    while (tempResult.LastEvaluatedKey || firstRun) {
        firstRun = false;
        tempResult  = await subjectData(tempResult.LastEvaluatedKey, userid, mode, version, startTime, endTime);
        addContent(self, '.');
        let obj;
        for (obj of tempResult.Items) {
            if (!isContinueProcessing(self)) {
                return;
            }
            writeLine(self, obj);
            if (obj.cl === 'on') {
                automodeOn++;
            } else if (obj.cl === 'off') {
                automodeOff++;
            } else if (obj.cl === 'trying') {
                automodeAttempting++;
            }
        }
    }
    const total = automodeOn + automodeOff  + automodeAttempting;
    let items = [0,0,0];
    if (total !==0) {
        items = [automodeOn/total, automodeOff/total, automodeAttempting/total];
    }
    return items;
}

export async function processSettings(userid, startTime, endTime, self, writeLine, checkIfDifferentFromPrevious) {
    let tempResult = {};
    tempResult.LastEvaluatedKey = "";
    let firstRun = true;
    let firstLine;
    let firstLineWritten = false;
    let previousLine;
    while (tempResult.LastEvaluatedKey || firstRun) {
        firstRun = false;
        tempResult = await subjectSettings(tempResult.LastEvaluatedKey, userid, "2010-06-01", endTime);
        addContent(self, '.');
        let obj;
        for (obj of tempResult.Items) {
            if (!isContinueProcessing(self)) {
                return;
            }
            if (obj.date < startTime) {
                firstLine = obj;
            } else if ((!firstLineWritten) && (obj.date >= startTime)) {
                if (!firstLine) {
                    firstLine = obj;
                    previousLine = obj;
                } else {
                    // this is the first line
                    firstLine.date = startTime;
                }
                previousLine = writeLine(self, firstLine);
                if (checkIfDifferentFromPrevious(self, obj, previousLine)) {
                    previousLine = writeLine(self, obj);
                }
                firstLineWritten = true;
            } else {
                if (checkIfDifferentFromPrevious(self, obj, previousLine)) {
                    previousLine = writeLine(self, obj);
                }
            }
        }
    }
    if ((!firstLineWritten) && firstLine) {
        // this is the first line
        firstLine.date = startTime;
        previousLine = writeLine(self, firstLine);
    }
}

async function readEnteralBolus(self, userid, startTime, endTime, version) {
    addContent(self, "Adding enteral bolus ");
    addOutputLine(self, "");
    addOutputLine(self, "Enteral_bolus (meal) ********************************************");
    addOutputLine(self, "Time                        CHO");
    addOutputLine(self, "(dd/mm/yyyy hh:mm)          (g)");

    await processDataCategory(userid, version, startTime, endTime, self, modeMeal, writeMeal);
}

function readVoids(self) {
    addOutputLine(self, "");
    addOutputLine(self, "Enteral_infusion ************************************************");
    addOutputLine(self, "Time                        Rate");
    addOutputLine(self, "(dd/mm/yyyy hh:mm)          (g/h)");
    addOutputLine(self, "");
    addOutputLine(self, "Parenteral_bolus ************************************************");
    addOutputLine(self, "Time                        CHO");
    addOutputLine(self, "(dd/mm/yyyy hh:mm)          (g)");
    addOutputLine(self, "");
    addOutputLine(self, "Parenteral_Infusion ************************************************");
    addOutputLine(self, "Time                        Rate");
    addOutputLine(self, "(dd/mm/yyyy hh:mm)          (g/h)");
    addOutputLine(self, "");
}

function writeStartTime(self, userid, startTime) {
    addOutputLine(self, "");
    addOutputLine(self, "Start ******************************************");
    addOutputLine(self, "Time (local time)           Bolus");
    addOutputLine(self, "(dd/mm/yyyy hh:mm)          (Y/N)");
    addOutputLine(self, getDateTime(startTime) + "  (" + getDateTime(startTime) + ")\tN");
    addOutputLine(self, "END");
}

async function readBolus(self, userid, startTime, endTime, version) {
    addContentNewLine(self, "");
    addContent(self, "Adding insulin bolus ");
    addOutputLine(self, "Insulin_bolus ********************************************");
    addOutputLine(self, "Time                        Bolus        Duration  Insulin");
    addOutputLine(self, "(dd/mm/yyyy hh:mm)          (U)            (min)    (S|R|N)");

    await processDataCategory(userid, version, startTime, endTime, self, modeBolus, writeBolus);
}

async function readInfusion(self, userid, startTime, endTime, version) {
    addContentNewLine(self, "");
    addContent(self, "Adding insulin infusion ");
    addOutputLine(self, "");
    addOutputLine(self, "Insulin_infusion ************************************************");
    addOutputLine(self, "Time                        Rate");
    addOutputLine(self, "(dd/mm/yyyy hh:mm)          (U/h)");

    await processDataCategory(userid, version, startTime, endTime, self, modeInfusion, writeInfusion);
}

async function readCgm(self, userid, startTime, endTime, version) {
    addContentNewLine(self, "");
    addContent(self, "Adding CGM values ");
    addOutputLine(self, "");
    addOutputLine(self, "Glucose_concentration ********************************************");
    addOutputLine(self, "Time                        conc");
    addOutputLine(self, "(dd/mm/yyyy hh:mm)         (mmol/L)");

    await processDataCategory(userid, version, startTime, endTime, self, modeCgm, writeCgm);
}

async function readKetone(self, userid, startTime, endTime, version) {
    addContentNewLine(self, "");
    addContent(self, "Adding ketone values ");
    addOutputLine(self, "");
    addOutputLine(self, "Ketone_concentration ********************************************");
    addOutputLine(self, "Time                        conc");
    addOutputLine(self, "(dd/mm/yyyy hh:mm)         (mmol/L)");

    await processDataCategory(userid, version, startTime, endTime, self, modeKetone, writeKetone);
}

async function readBg(self, userid, startTime, endTime, version) {
    addContentNewLine(self, "");
    addContent(self, "Adding BG values ");
    addOutputLine(self, "");
    addOutputLine(self, "Fingerstick_glucose_concentration ********************************************");
    addOutputLine(self, "Time                        conc");
    addOutputLine(self, "(dd/mm/yyyy hh:mm)         (mmol/L)");

    await processDataCategory(userid, version, startTime, endTime, self, modeBg, writeBg);
}

async function subjectData(lastEvaluatedKey, userId, mode, version, startDate, endDate) {
    let myInit = {
        queryParams: {
            subjectID: mode + ":" + version + ":" + userId,
            startDate: startDate,
            endDate: endDate
        }
    };
    if (lastEvaluatedKey && ("" !== lastEvaluatedKey)) {
        myInit.queryParams.ExclusiveStartKey = lastEvaluatedKey[globals.subjectID];
        myInit.queryParams.ExclusiveStartKeyDate = lastEvaluatedKey[globals.dateKey];
    }
    const { body } = await get( { apiName: "data", path: "/data", options: myInit } ).response;
    return body.json();
}

async function subjectSettings(lastEvaluatedKey, userId, startDate, endDate) {
    let myInit = {
        queryParams: {
            subjectID: userId,
            startDate: startDate,
            endDate: endDate
        }
    };
    if (lastEvaluatedKey && ("" !== lastEvaluatedKey)) {
        myInit.queryParams.ExclusiveStartKey = lastEvaluatedKey[globals.subjectID];
        myInit.queryParams.ExclusiveStartKeyDate = lastEvaluatedKey[globals.dateKey];
    }
    const { body } = await get( { apiName: "data", path: "/settings", options: myInit } ).response;
    return body.json();
}

export function getDateTime(dateOrig) {
    return dateOrig.substr(8, 2) + '/' +
        dateOrig.substr(5, 2) + '/' +
        dateOrig.substr(0, 4) +
        dateOrig.substr(10, 6);
}


